<template>
    <div class="system-upgrade" @click="handleJump()">
        <div class="tips-wrap">
            <div class="tips-img">
                <img class="icon" src="../assets/images/forbidden-goose.png" alt="">
            </div>
            <div class="tips-title">下线公告</div>
            <div class="tips-text">您好，天天提鹅已下线，喜欢我的朋友们可以去我的朋友 “天天来提额” 参与提额活动哦</div>
            <div class="tips-text2">>>点击去天天来提额，最快3天可提 </div>
        </div>
    </div>
</template>
<style rel="stylesheet/scss" lang="scss" scope>
    .system-upgrade { min-height: 100vh;background: linear-gradient(180deg, rgba(76, 35, 234, 1) 0%, rgba(50, 2, 197, 1) 100%);position:relative;}
    .tips-wrap{
        width: 2.75rem;
        position:absolute;
        left:50%;
        top:45%;
        transform:translate(-50%,-50%);
    }
    .tips-img {width: 2.75rem;}
    .icon{
        width:100%;
    }
    .tips-title {color: #E6DFFF;font-size: 0.22rem;margin-top: 0.2rem;}
    .tips-text {color: #E6DFFF;font-size: 0.14rem;margin-top: 0.15rem;}
    .tips-text2 {color: #F97331;font-size: 0.16rem;margin-top: 0.5rem;}
</style>
<script type="javascript">
    export default {
        data() {
            return {
            }
        },
        mounted(){
            setTimeout(()=>{
                this.handleJump()
            },6000)
        },
        methods: {
            handleJump() {
                this.$jumpUrl('https://show.jd.com/m/X0eM/?pageKey=X0eM&channel=xiaxian')
            }
        }
    }
</script>
